// Copyright (c) 2017 PlanGrid, Inc.

import React, { Component } from 'react';

//import FileViewer from 'react-file-viewer';
import '../less/DocViewer.less';

import { Row, Col, Button, Popconfirm } from 'antd';

import FileSaver from 'file-saver';
import MediaServices from '../services/media/Media';


export default class DocList extends Component {

  image_ext = ['jpg', 'jpeg', 'png'];
  token = localStorage.getItem('token');

  constructor(props) {
    super(props);
    this.state = {
      loading: true,

    };
  }




  downloadFile() {

    MediaServices.download(this.props.file.id, async (res) => {
      const blob = new Blob([res.data], { type: this.props.file.mime_type });
      FileSaver.saveAs(blob, this.props.file.nome);
    }, () => null)
  }

  getTextStyle() {
    return this.props.file.deleted ? { color: 'red' } : {};
  }

  previewFile() {

    /*this.setState({open_modal: true});*/
    MediaServices.download(this.props.file.id, async (res) => {
      const blob = new Blob([res.data], { type: this.props.file.mime_type });

      var fileURL = window.URL.createObjectURL(blob);
      window.open(fileURL, '_blank');

    }, () => null)
  }

  canPreview() {
    return (this.props.file.ext === 'pdf' || this.image_ext.indexOf(this.props.file.ext) !== -1) ? true : false;
  }

  getFile() {
    return <Button type="link" style={this.getTextStyle()} onClick={()=> this.canPreview() ? this.previewFile() : this.downloadFile()}>{this.props.file.nome_file}</Button>
  }

  render() {
    return <Row gutter={8} style={{ marginBottom: 8 }}>
      <Col
        style={{ overflow: 'hidden', textOverflow: 'ellipsis' }}
        span={this.canPreview() && this.props.canRemove ? 16 : ((!this.props.canRemove && !this.canPreview()) ? 24 : 20)}
      >
        {
          this.getFile()
        }
      </Col>
      {
        this.canPreview()
          ?
          <Col span={4}>
            <Button size="small" shape="circle" icon="download" type="default" onClick={() => {
              this.downloadFile()
            }}>
            </Button>
          </Col>
          : null
      }
      {
        this.props.canRemove
          ?
          <Col span={4}>
            <Popconfirm placement="leftTop" title="Sicuro di voler rimuovere questo elemento?"
              onConfirm={() => this.props.onRemove(this.props.file)} okText="Si" cancelText="No">
              <Button
                loading={this.props.removing}
                size="small" shape="circle" icon="close" type="danger" ghost>
              </Button>
            </Popconfirm>
          </Col>
          : null
      }


    </Row>

  }
}
